export interface ContactVisibility {
  showPhone: boolean;
  showWhatsApp: boolean;
  showEmail: boolean;
  preferredContact: PreferredContact;
}

export type PreferredContact = 'phone' | 'whatsapp' | 'email' | 'form';

export const PREFERRED_CONTACT_OPTIONS = [
  { value: 'phone', labelKey: 'objects.wizard.contactOptions.phone', icon: 'pi pi-phone' },
  { value: 'whatsapp', labelKey: 'objects.wizard.contactOptions.whatsapp', icon: 'pi pi-whatsapp' },
  { value: 'email', labelKey: 'objects.wizard.contactOptions.email', icon: 'pi pi-envelope' },
  { value: 'form', labelKey: 'objects.wizard.contactOptions.form', icon: 'pi pi-comment' },
];

export const DEFAULT_CONTACT_VISIBILITY: ContactVisibility = {
  showPhone: false,
  showWhatsApp: false,
  showEmail: false,
  preferredContact: 'form',
};
